import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';

const urls = {
  createSPEmployee: 'spEmployee',
  uploadEmployeeProfileImage: 'spEmployee/uploadEmployeeImage',
  allSPEmployee: 'spEmployee/allEmployeesByUserName',
  employeeByEmployeeId: 'spEmployee',
  employeeResetPassword: 'spEmployee/resetPassword'
};

export const createSpEmployeeApi = createAsyncThunk('serviceplug/createSpEmployeeApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createSPEmployee}`,
      method: 'post',
      data: params
    });
    const data = await response.data;

    return data?.result;
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const updateSPEmployeeApi = createAsyncThunk('serviceplug/updateSPEmployeeApi', async (params, thunkApi) => {
  try {
    const response = await axios.request({
      url: `${urls.createSPEmployee}`,
      method: 'put',
      data: params
    });
    const data = await response.data;

    return data?.result;
  } catch (err) {
    return thunkApi.rejectWithValue('Something went wrong. Please try again!');
  }
});

export const uploadEmployeeProfileImageApi = createAsyncThunk(
  'user/uploadEmployeeProfileImageApi',
  async (params, thunkApi) => {
    try {
      const response = await axios.request({
        url: `${urls.uploadEmployeeProfileImage}`,
        method: 'post',
        data: params
      });
      const data = await response.data;

      if (data && data.result) {
        return data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong');
    } catch (err) {
      console.log(err, 'asldksw');
      return thunkApi.rejectWithValue('Something went wrong. Please try again!');
    }
  }
);

export const deleteEmployeeApi = createAsyncThunk('serviceplug/deleteEmployeeApi', async (params, thunkApi) => {
  try {
    const response = await axios.delete(`${urls.createSPEmployee}`, { params });
    if (response.data) {
      return response.data;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getAllSPEmployeeApi = createAsyncThunk('serviceplug/getAllSPEmployeeApi', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.allSPEmployee, { params });
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});

export const getEmployeeByEmployeeIdApi = createAsyncThunk(
  'serviceplug/getEmployeeByEmployeeIdApi',
  async (params, thunkApi) => {
    console.log(params, 'dflkmle');
    try {
      const response = await axios.get(urls.employeeByEmployeeId, { params });
      if (response.data?.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getEmployeeResetPasswordApi = createAsyncThunk(
  'serviceplug/getEmployeeResetPasswordApi',
  async (params, thunkApi) => {
    console.log(params, 'dflkmle');
    try {
      const response = await axios.get(urls.employeeResetPassword, { params });
      if (response.data?.result) {
        return response.data.result;
      }
      return thunkApi.rejectWithValue('Something went wrong with this');
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
